<script lang="ts">
      import { onMount, untrack } from 'svelte'
      import { getAnalyticsContext } from './ts/Anatytics.svelte'

      function defaultConsent() {
            return {
                  rtgId: id,
                  consent: null /* souhlas od návštěvníka na odeslání retargetingového hitu, povolené hodnoty: 0 (není souhlas) nebo 1 (je souhlas) */,
            }
      }

      function consentUpdate(consent: any) {
            if( ! window.rc || !id) return
            var retargetingConf = {...consent, rtgId: id}
            //console.log(retargetingConf)
            window.rc.retargetingHit(retargetingConf)
      }

      onMount(() => {
            if (!window.rc || !window.sznIVA) {
                  console.log('seznam not ready.')
                  return
            }

            window.sznIVA.IS.updateIdentities({
                  eid: null /* email či zahashovaný email*/,
            })

            consentUpdate(defaultConsent())
      })

      const analytics = getAnalyticsContext()

      $effect(() => {
            analytics.consent
            untrack(() => {
                  //console.log('sklik consent update', analytics.consent)
                  if (analytics.consent.sklik) consentUpdate(analytics.consent.sklik)
            })
      })

      let { id = '141604' } = $props()
</script>

<svelte:head>
      {#if id != ''}
            <script type="text/javascript" src="https://c.seznam.cz/js/rc.js"></script>
            <script>
                  window.sznIVA.IS.updateIdentities({
                        eid: null /* email či zahashovaný email*/,
                  })
            </script>
      {/if}
</svelte:head>

<style lang="postcss">
</style>
